module.exports = __webpack_public_path__ + "c9143a819c83eda7be1165d94cd14dd9.png";